// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"2048bbf6","314":"2048bbf6","453":"6b5bc2bc","695":"2048bbf6","933":"2048bbf6"}[chunkId] + ".chunk.js";
};